module.exports = __webpack_public_path__ + "static/img/fullScreen-1.d06926b.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/fullScreen-1.png
// module id = eTwk
// module chunks = 1